module.exports = __webpack_public_path__ + "static/media/mail.2b5395e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail.svg
// module id = 738
// module chunks = 0